module.exports = __webpack_public_path__ + "img/social-media-marketing-banner2.9987d127.jpg";